// tslint:disable
export enum PartyExternalIdType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description MEMBER ID
     */
    MEMBERID = 1,
    /**
     * @description SOCIAL SECURITY NUMBER (SSN)
     */
    SOCIALSECURITYNUMBERSSN = 2,
    /**
     * @description FEDERAL EMPLOYER IDENTIFICATION NUMBER (EIN)
     */
    FEDERALEMPLOYERIDENTIFICATIONNUMBEREIN = 3,
    /**
     * @description DRIVERS LICENSE NUMBER
     */
    DRIVERSLICENSENUMBER = 4,
    /**
     * @description DEA NUMBER
     */
    DEANUMBER = 5,
    /**
     * @description NPI NUMBER
     */
    NPINUMBER = 6,
    /**
     * @description GROUP ID
     */
    GROUPID = 7,
    /**
     * @description EMPLOYEE ID
     */
    EMPLOYEEID = 8,
    /**
     * @description STATE LICENSE NUMBER
     */
    STATELICENSENUMBER = 9,
    /**
     * @description PROCESSOR CONTROLLER NUMBER
     */
    PROCESSORCONTROLLERNUMBER = 10,
    /**
     * @description BANK IDENTIFICATION NUMBER
     */
    BANKIDENTIFICATIONNUMBER = 11,
    /**
     * @description MEDICAL ID
     */
    MEDICALID = 12,
    /**
     * @description IS GOVERNMENT
     */
    ISGOVERNMENT = 13,
    /**
     * @description ASSIST RX CASE NUMBER
     */
    ASSISTRXCASENUMBER = 14,
    /**
     * @description IS MEDICAL BENEFIT
     */
    ISMEDICALBENEFIT = 15,
    /**
     * @description COVERAGE START DATE
     */
    COVERAGESTARTDATE = 16,
    /**
     * @description COVERAGE END DATE
     */
    COVERAGEENDDATE = 17,
    /**
     * @description PLAN YEAR
     */
    PLANYEAR = 18,
    /**
     * @description Virmedica Pratice ID
     */
    VirmedicaPraticeID = 19,
    /**
     * @description Virmedica Location ID
     */
    VirmedicaLocationID = 20,
    /**
     * @description Virmedica Provider ID
     */
    VirmedicaProviderID = 21,
    /**
     * @description Virmedica HCP Provider ID
     */
    VirmedicaHCPProviderID = 22,
    /**
     * @description Virmedica Master Payer ID
     */
    VirmedicaMasterPayerID = 23,
    /**
     * @description Virmedica Payer ID
     */
    VirmedicaPayerID = 24,
    /**
     * @description Max RTE Payor ID
     */
    MaxRTEPayorID = 25,
    /**
     * @description Provider Transaction Access Number
     */
    ProviderTransactionAccessNumber = 26,
    /**
     * @description Infinitus ID
     */
    InfinitusID = 27,
    /**
     * @description EvinceMed Id
     */
    EvinceMedId = 28,
}
(PartyExternalIdType as any)['VIRMEDICAPRATICEID'] = 19;
(PartyExternalIdType as any)['VIRMEDICALOCATIONID'] = 20;
(PartyExternalIdType as any)['VIRMEDICAPROVIDERID'] = 21;
(PartyExternalIdType as any)['VIRMEDICAHCPPROVIDERID'] = 22;
(PartyExternalIdType as any)['VIRMEDICAMASTERPAYERID'] = 23;
(PartyExternalIdType as any)['VIRMEDICAPAYERID'] = 24;
(PartyExternalIdType as any)['MAXRTEPAYORID'] = 25;
(PartyExternalIdType as any)['PROVIDERTRANSACTIONACCESSNUMBER'] = 26;
(PartyExternalIdType as any)['INFINITUSID'] = 27;
(PartyExternalIdType as any)['EVINCEMEDID'] = 28;
